/**
 * Configuración de funcionalidades por plan (frontend)
 * Mirror del backend/config/planFeatures.js
 */

const PLAN_HIERARCHY = {
  trial: 99,
  avanzado: 2,
  pro: 1
}

// Features que requieren plan Avanzado
// Todo lo que NO está aquí = disponible en Pro
const AVANZADO_FEATURES = [
  'ausencias',
  'tipos_ausencia',
  'correcciones_flujo',
  'notificaciones_auto',
  'geolocalizacion'
]

/**
 * Comprueba si el plan tiene acceso a una feature
 * @param {string} plan - 'pro', 'avanzado', 'trial'
 * @param {string} feature - clave de feature
 * @returns {boolean}
 */
export function canAccess(plan, feature) {
  // Si no es feature restringida, siempre accesible (Pro)
  if (!AVANZADO_FEATURES.includes(feature)) return true

  const planLevel = PLAN_HIERARCHY[plan] || 0
  const requiredLevel = PLAN_HIERARCHY['avanzado'] || 0
  return planLevel >= requiredLevel
}

/**
 * Obtiene el plan efectivo (considerando trial)
 */
export function getEffectivePlan(empresaInfo) {
  if (!empresaInfo) return 'pro'
  if (empresaInfo.subscription_status === 'trialing') return 'trial'
  return empresaInfo.plan || 'pro'
}
